import React, { useState } from "react";
import useUpdateAdminPassword from "../hooks/useUpdateAdminPassword";
import { useNavigate } from "react-router-dom";





const ResetPassword = ({ email }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { isLoading, error, updatePassword } = useUpdateAdminPassword();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!newPassword || !confirmPassword) {
      alert("Please fill in both fields");
      return;
    }
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    const res = await updatePassword({ email, newPassword });
    if (res.success) {
      setNewPassword("");
      setConfirmPassword("");
    }
  };

  return (
    <div className="flex flex-col justify-center max-w-xl mx-auto  bg-white rounded-r-xl">
      <h2 className="text-3xl font-bold mb-2 text-black text-center">Reset Password</h2>
      <p className="text-gray-600 text-sm mb-6 text-center">
        Reset password for <span className="font-medium">{email}</span>
      </p>

      {error && <p className="text-red-600 mb-4 text-center font-medium">{error}</p>}

      <div className="flex flex-col gap-4 ml-10 mr-10">
        <input
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="w-full px-4 py-3 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="w-full px-4 py-3 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
        />

        <button
          onClick={handleSubmit}
          disabled={isLoading}
          className={`w-full py-3 rounded-lg text-white font-semibold ${
            isLoading ? "bg-gray-500 cursor-not-allowed" : "bg-black hover:bg-gray-800"
          }`}
        >
          {isLoading ? "Resetting..." : "Reset Password"}
        </button>

        <button
          onClick={() => navigate("/login")}
          className="w-full mt-2 text-sm text-gray-600 hover:text-black underline"
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};


export default ResetPassword;
